import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CustomHttpClientService {

  constructor(private http: HttpClient) {}

  private createAuthHeader(): HttpHeaders {
    let token = localStorage.getItem('token');
    return new HttpHeaders({
      'authorization': token || ''  // Append token if it exists
    });
  }

    // GET method with optional type parameter
  get<T>(url: string): Observable<T> {
    const headers = this.createAuthHeader();
    return this.http.get<T>(url, { headers });
  }

    // DELETE method with optional type parameter
  delete<T>(url: string): Observable<T> {
    const headers = this.createAuthHeader();
    return this.http.delete<T>(url, { headers });
  }

    // POST method with optional type parameter
    post<T>(url: string, data: any): Observable<T> {
      const headers = this.createAuthHeader();
      return this.http.post<T>(url, data, { headers });
    }
  
    // PUT method with optional type parameter
    put<T>(url: string, data: any): Observable<T> {
      const headers = this.createAuthHeader();
      return this.http.put<T>(url, data, { headers });
    }
  

}
